module.exports = __webpack_public_path__ + "img/light-cloudy-snow.ce412d0d.svg";